import React from 'react';
import { useTranslation } from 'react-i18next';
import { TicketCard } from '../jo-components/cards/ticketCard/ticketCard';
import { APIAction } from './api-action/api-action';
import ActionCard, { getAttributeForAction } from '../jo-components/cards/actionCard/actionCard';
import OrderCard from '../jo-components/cards/orderCard/orderCard';
import ItemCardInfos from '../jo-components/cards/itemCard/components/itemCardInfos/itemCardInfos';
import NeoLayout from '../neoLayout';
import './order-menu.css';

export function OrderMenu({ config, onSubmit=()=>{}, storage }) {
    const { t } = useTranslation();

    const menu = config['order-menu'];
    const { order, membership_code, tickets } = menu;
    const { display_unavailable_actions = false } = menu.settings || [];
    const actions = menu?.actions?.filter(action => action.enabled || display_unavailable_actions);

    // JSON.parse remove empty attributes
    const membership_header = JSON.parse(JSON.stringify({ title: membership_code?.label, subtitle: membership_code?.code }));
    // membership_header after menu for overwrite priority
    const {title, subtitle} = {...menu, ...membership_header};

    return (
        <div className="wz-order-menu">
            <div className="wz-list">
				{(title || subtitle) && (<div>
                	<NeoLayout.Header config={{title: title}} />
                	<NeoLayout.Subtitle config={{subtitle: subtitle}} />
				</div>)}
                {order && (<OrderCard order={order} action={null} event={order.event}>
                    <ItemCardInfos alternativeStyle title={order.informations_title} informations={order.informations} />
                </OrderCard>)}
            </div>
            {actions?.length > 0 && (<div className="wz-list">
                <NeoLayout.Header className="wz-section-title" config={{title: menu.actions_title}} />
                {actions.map((action, index) => (
                    <APIAction key={index} name={action.type} actions={actions}>
                        <ActionCard
                            {...action}
							icon={getAttributeForAction(action.type, 'icon')}
							type={getAttributeForAction(action.type, 'type')}
							size={getAttributeForAction(action.type, 'size')}
                            disabled={!action.enabled}
                            onClick={() => {
                                onSubmit({
                                    data: {
                                        action: action.type,
                                        payload: {
                                            order_id: order.id
                                        }
                                    }
                                })
                            }}
                        />
                    </APIAction>
                ))}
            </div>)}
            <div className="wz-list">
                <NeoLayout.Header className="wz-section-title" config={{title: t('widget.list.tickets', {count: tickets.length})}} />
                {
                    tickets.map(ticket => (
                        <TicketCard type={'resale.header'} key={ticket.id} ticket={ticket} onSubmit={onSubmit} />
                    ))
                }
            </div>
        </div>
    )
}
